import { motion } from 'framer-motion'
import { AnimatePresence } from 'framer-motion'
import { SendIcon } from 'lucide-react'
import useDeviceDetect from '~/src/hooks/useDeviceDetect'

const HomeIGShareCTA = () => {
  const { isInstagram, loading } = useDeviceDetect()

  return (
    <div
      className='pointer-events-none fixed inset-x-0 bottom-4 flex items-center justify-center'
      style={
        {
          // right: 30,
        }
      }
    >
      <AnimatePresence>
        {!loading && isInstagram && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ delay: 1 }}
          >
            <div
              className='flex items-center justify-center space-x-2 rounded-2xl px-4 py-2 text-black shadow-lg'
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(8px)',
              }}
            >
              <div>
                <div className='whitespace-nowrap text-sm font-semibold'>
                  Send a reminder
                </div>
                <div className='text-xs opacity-90'>
                  Share with a friend or as a reminder to yourself!
                </div>
              </div>
              <SendIcon
                size={24}
                strokeWidth={2}
                style={{
                  transform: 'rotate(20deg)',
                }}
              />
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: -8,
                left: '49.5%',
                transform: 'translateX(-50%)',
                // right: 70,
                width: 16,
                height: 16,
                clipPath: 'polygon(0% 50%, 50% 100%, 100% 50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(8px)',
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default HomeIGShareCTA
